import "./tools.css"
const Tools = () => {
    return (
        <div className="tooltop">
            <h1 className="tools_heading">TOOLS USED</h1>
            <div className="tools">
                <div >
                    <img src="/images/vslogo.png" alt="vs-code"/>
                     <h3>VS Code</h3>
                </div>
                <div>
                    <img src="/images/github-logo.png" />
                    <h3>Github</h3>
                </div>
                <div>
                    <img src="https://miro.medium.com/max/2400/0*BRl-uL7N9LF-1hiD.png" />
                    <h3>Netlify</h3>
                </div>
            </div>
        </div>
    )
}

export default Tools